export const pageView = {
  tracker: 'trackPageView',
  context: [
    'mainCookie',
    'abTests',
    'consentCookie',
  ],
};

// new-indexpage tracking
// https://github.com/ecosia/ecosia-analytics/blob/development/trackers/new-indexpage.js

export const trackTreePlantingProjectLink = (href) => ({
  tracker: 'trackStructEvent',
  data: {
    category: 'tree_planting_project',
    action: 'click',
    label: href,
    property: 'index',
    value: '0',
  },
  context: [
    'abTests',
  ],
});

export const trackMapDiscoverProjectLink = (href) => ({
  tracker: 'trackStructEvent',
  data: {
    category: 'map_discover_projects',
    action: 'click',
    label: href,
    property: 'index',
    value: '0',
  },
  context: [
    'abTests',
  ],
});

export const trackFinancialReportsLink = (href) => ({
  tracker: 'trackStructEvent',
  data: {
    category: 'financial_reports',
    action: 'click',
    label: href,
    property: 'index',
    value: '0',
  },
  context: [
    'abTests',
  ],
});

// index tracking
// https://github.com/ecosia/ecosia-analytics/blob/development/trackers/index.js

export const trackVideoPlay = {
  tracker: 'trackStructEvent',
  data: {
    category: 'video',
    action: 'start',
    label: 'engagement',
    property: 'index',
    value: '0',
  },
  context: [
    'abTests',
  ],
};

export const trackMainNavItemClick = (payload) => ({
  tracker: 'trackStructEvent',
  data: {
    category: 'menu',
    action: 'click',
    label: 'main',
    property: payload.origin,
    value: '0',
  },
});

export const trackScrollTo = (section) => ({
  tracker: 'trackStructEvent',
  data: {
    category: 'scroll_to',
    action: 'scroll',
    label: section,
    property: 'index',
    value: '0',
  },
  context: [
    'abTests',
  ],
});
